module.exports = __webpack_public_path__ + "img/badge_1feuille@2x.dfb54155.png";